import routerOptions0 from "/home/bede/bede-web/node_modules/.pnpm/nuxt@3.16.1_@parcel+watcher@2.5.0_@types+node@22.13.10_db0@0.3.1_encoding@0.1.13_ioredi_a0c24836089298352991004b3cb229ec/node_modules/nuxt/dist/pages/runtime/router.options.js";
const configRouterOptions = {
  hashMode: false,
  scrollBehaviorType: "auto"
}
export const hashMode = false
export default {
...configRouterOptions,
...routerOptions0,
}